module.exports = __webpack_public_path__ + "static/media/26.348d5880.jpg";